import { useContext, useEffect, useState } from "react";
import FormField from "../../../../components/formField/formField";
import { FormFieldProps } from "../../../../components/formField/types/formFieldProps";
import KrFormContext, { KrEndangeredAreaFormTypes, KrLandslideFormTypes, NavHeadingsKROEnum, NavHeadingsKRTZEum } from "../../../../contexts/krFormContext";
import { styleFormFieldHalf } from "../../../../components/shared/stylization";
import { padZeros } from "../../../../helpers/idNumber";
import { getAddCommentBtnDetails, getFieldRef, getItemRef, prepareGminy } from "../../../../helpers/form";
import { FormSectionProps } from "./shared/types/formSectionProps";
import { createConfigValidation } from "../../../../helpers/validation/validation";
import { ObjectType } from "../../../../contexts/types/card";
import { KROFieldDict, KRTZFieldDict } from "../../shared/commentsSidebar/fieldDict";

const RegistrationNumber = (props: FormSectionProps) => {
    const { krForm } = useContext(KrFormContext);
    const [errorTipText, setErrorTipText] = useState("");
    const [reload, setReload] = useState(false);

    // Validation
    useEffect(() => {
        if (krForm.config?.check && !krForm.config.isValid) {
            setError(krForm.config?.ValidationError!["numeR_IDENTYFIKACYJNY"], setErrorTipText);
            setReload(!reload);
        }
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [krForm.config?.check])

    const setError = (errorMsg: string, callback: any) => {
        if (errorMsg !== '') {
            callback(errorMsg);
        }
    }

    let idNumber: number | string | undefined = "";

    const getAttributes = () => {
        return props.objectType === ObjectType.KRTZ ? (krForm as KrEndangeredAreaFormTypes)?.endangeredAreaAttributes : (krForm as KrLandslideFormTypes)?.landslideAttributes;
    }

    const setIdNumber = () => {
        const attributes = getAttributes();
        if (attributes?.numeR_IDENTYFIKACYJNY) {
            idNumber = padZeros(attributes?.numeR_IDENTYFIKACYJNY as number);
        }
    }

    setIdNumber();

    const getGminaAttributes = () => {
        return props.objectType === ObjectType.KRTZ ? (krForm as KrEndangeredAreaFormTypes).endangeredAreaGminy : (krForm as KrLandslideFormTypes).landslideGminy;
    }

    const createValueRegistrationNumber = () => {
        const gminaAttributes = getGminaAttributes();
        gminaAttributes?.sort((a, b) => {
            if (a.kolejnosc !== undefined && a.kolejnosc != null && b.kolejnosc != null && b.kolejnosc !== undefined) {
                return b.kolejnosc - a.kolejnosc;
            }
            return 0;
        });
        let registrationNumber = "";
        if (gminaAttributes != null && gminaAttributes.length > 0) {
            gminaAttributes?.forEach((value, index: number) => {
                if (index === 0) registrationNumber += `${prepareGminy(value.teryt)}-${idNumber}`;
                else registrationNumber += `,\n${prepareGminy(value.teryt)}-${idNumber}`;
            });
        } else {
            return idNumber;
        }
        return registrationNumber;
    }

    const getNumerRoboczy = () => {
        const attributes = getAttributes();
        return attributes?.numeR_ROBOCZY ? attributes.numeR_ROBOCZY : "";
    }

    const registrationNumberKRFieldDict = props.objectType === ObjectType.KRO ? KROFieldDict.nrEwid_numerEwidencyjny : KRTZFieldDict.nrEwid_numerEwidencyjny;
    var inputPropsRegistrationNumber: FormFieldProps = {
        labelName: "Numer ewidencyjny",
        value: `${createValueRegistrationNumber()}`,
        style: styleFormFieldHalf,
        type: "text",
        configValidation: createConfigValidation("onlyRequired", false),
        disabled: true,
        hasTextarea: true,
        validationError: krForm.config?.isValid !== undefined ? !krForm.config?.isValid : false,
        tipText: errorTipText,
        reload: reload,
        addCommentBtn: getAddCommentBtnDetails(props.editMode!, registrationNumberKRFieldDict, "Numer ewidencyjny", props.setNewCommentFieldDetails!),
        inputRef: (node: any) => {getFieldRef(node, registrationNumberKRFieldDict, props.getMapForComment!)},
        setCommentsFilter: () => { if(props.setCommentsFilter) props.setCommentsFilter(registrationNumberKRFieldDict); },
        isMarkedForCommentFilter: props.markedFieldForCommentFiltering === registrationNumberKRFieldDict
    }

    //this field cannot be validated
    const workingNumberKRFieldDict = props.objectType === ObjectType.KRO ? KROFieldDict.nrEwid_numerRoboczy : KRTZFieldDict.nrEwid_numerRoboczy;
    var inputPropsWorkingNumber: FormFieldProps = {
        labelName: "Numer roboczy",
        value: `${getNumerRoboczy()}`,
        style: styleFormFieldHalf,
        type: "text",
        disabled: true,
        hasTextarea: true,
        addCommentBtn: getAddCommentBtnDetails(props.editMode!, workingNumberKRFieldDict, "Numer roboczy", props.setNewCommentFieldDetails!),
        inputRef: (node: any) => {getFieldRef(node, workingNumberKRFieldDict, props.getMapForComment!)},
        setCommentsFilter: () => { if(props.setCommentsFilter) props.setCommentsFilter(workingNumberKRFieldDict); },
        isMarkedForCommentFilter: props.markedFieldForCommentFiltering === workingNumberKRFieldDict
    }

    return (
        <div>
            <h2 ref={(node) => props.objectType === ObjectType.KRO ? getItemRef(node, NavHeadingsKROEnum.RegistrationNumber, props.getMapForNavScroll!) : 
                getItemRef(node, NavHeadingsKRTZEum.RegistrationNumber, props.getMapForNavScroll!) }>
                    1. Numer ewidencyjny
            </h2>
            <div className="krFormSection-flex">
                <FormField {...inputPropsRegistrationNumber} />
                <FormField {...inputPropsWorkingNumber} />
            </div>
        </div>
    )
}

export default RegistrationNumber;